// extracted by mini-css-extract-plugin
export default {"saveModalTitle":"create-new-preset_saveModalTitle__6CN7n","saveInputName":"create-new-preset_saveInputName__YAN4k"};